<template>
  <div class="competitor">
    <span class="id" title="Id">{{ competitor.id }}</span>
    <div :class="classMedal"></div>
    <input class="ranking" type="text" :value="competitor.ranking" @change="changeRanking" title="Ordre final"/>
    <input class="order" type="text" :value="competitor.order" @change="changeOrder" title="Ordre de départ"/>
    <div class="country">
      <img :src="countryUrl(countryId)" v-if="countryId"/>
    </div>
    <el-autocomplete
      class="team"
      v-model="teamName"
      :fetch-suggestions="searchedTeam"
      placeholder="Equipe"
      @select="changeTeam"
      @clear="clearTeam"
      :trigger-on-focus="false"
      :clearable="true"
      size="mini">
        <template slot-scope="{ item }">
          <span :title="item.value">{{ item.value }}</span>
        </template>
    </el-autocomplete>
    <el-switch class="medal" v-model="gold" title="Medaille d'or" active-color="gold" />
    <el-switch class="medal" v-model="silver" title="Medaille d'argent" active-color="silver" />
    <el-switch class="medal" v-model="bronze" title="Medaille de bronze" active-color="maroon" />
    <div class="persons">
      <el-autocomplete
        prefix-icon="el-icon-search"
        placeholder="Ajouter athlète"
        v-model="searchState"
        @select="addPerson"
        :fetch-suggestions="searchPerson"
        :trigger-on-focus="false"
        size="mini"
        popper-class="search-person-popper">
          <template slot-scope="{ item }">
            <img
              class="flag"
              v-for="country in item.countries"
              :key="country.id"
              :src="countryUrl(country.id)"
              :title="country.nameFr" />
            <span class="name" :title="searchTitle(item)">
              <strong>{{ item.nameFr }}</strong>
              <small>{{ item.firstnameFr }}</small>
              <small>&nbsp;[{{ item.id }}]</small>
            </span>
          </template>
      </el-autocomplete>
      <div class="list">
        <competitor-person v-for="item in persons" :key="item.id" :competitorPerson="item"/>
      </div>
    </div>
    <competitor-detail type="record" parent="Competitor" :parentId="competitor.id" :id="competitor.recordId"/>
    <competitor-detail type="qualify" parent="Competitor" :parentId="competitor.id" :id="competitor.qualifyId" :disciplineId="disciplineId"/>
    <competitor-detail type="status" parent="Competitor" :parentId="competitor.id" :id="competitor.statusId"/>
    <div v-if="scoreDiscipline.length > 0" class="scores">
      <competitor-score-status
        v-for="item in scoreDiscipline"
        :key="item.id"
        :scoreDiscipline="item"
        :competitorId="competitor.id"
        :scoreAutomatic="scoreAutomatic"
        :statusGameId="statusId"
        :disciplineId="disciplineId" />
    </div>
    <!-- <div v-else class="scores">
      <button v-if="!statusOpen" title="Ajouter un nouveau score" @click="statusOpen = true" :data-state="state(status)">
        <i class="el-icon-circle-plus-outline" />
      </button>
      <select v-if="statusOpen" class="status" v-model="statusGame" @blur="statusOpen = false">
        <option v-for="item in statuses" :key="item.id" :title="item.name" :data-state="state(item)">
          {{ item.name }}
        </option>
      </select>
      <div class="list">
        <competitor-score v-for="item in scores" :key="item.id" :competitorScore="item"/>
      </div>
    </div> -->
    <scores :scoreTypes="scoreTypes" :competitorId="competitor.id"/>
    <button @click="remove"><i class="el-icon-delete"/>Supprimer</button>
  </div>
</template>

<script>
import CompetitorDetail from '@/components/sport/games/CompetitorDetail'
import CompetitorPerson from '@/components/sport/games/CompetitorPerson'
// import CompetitorScore from '@/components/sport/games/CompetitorScore'
import Scores from '@/components/sport/games/Scores'
import CompetitorScoreStatus from '@/components/sport/games/CompetitorScoreStatus'
import { date } from '@/helpers/format'

export default {
  name: 'SportGamesCompetitor',
  // components: { CompetitorDetail, CompetitorPerson, CompetitorScore, CompetitorScoreStatus, Scores },
  components: { CompetitorDetail, CompetitorPerson, CompetitorScoreStatus, Scores },
  props: {
    competitor: Object,
    eventUnitId: Number,
    sportId: Number,
    disciplineId: Number,
    scoreAutomatic: Boolean,
    statusId: Number,
    scoreTypes: Array
  },
  data () {
    return {
      teamState: null,
      searchState: '',
      callback: null,
      statusOpen: false, /* To delete */
      newScoreV2: false
    }
  },
  computed: {
    classMedal () {
      let value = 'medals'
      value += this.competitor.gold ? ' gold' : ''
      value += this.competitor.silver ? ' silver' : ''
      value += this.competitor.bronze ? ' bronze' : ''
      return value
    },

    team () { return this.competitor.teamId ? this.$store.getters['Sport/Team/get'](this.competitor.teamId) : null },
    teamName: {
      get () { return this.teamState ? this.teamState : (this.team ? (this.team.order ? '#' + this.team.order + ' ' : '') + this.team.nameFr + ' [' + this.team.id + ']' : '') },
      set (value) { this.teamState = value }
    },

    countryId () {
      let value = null
      if (this.team) {
        value = this.team.club.countryId
      } else if (this.persons && this.persons[0] && this.persons[0].countries && this.persons[0].countries[0]) {
        value = this.persons[0].countries[0].id
      }
      return value
    },

    gold: {
      get () { return this.competitor.gold },
      set (value) {
        const data = { id: this.competitor.id, gold: value, silver: 0, bronze: 0 }
        this.$store.dispatch('Sport/Competitor/put', data)
      }
    },
    silver: {
      get () { return this.competitor.silver },
      set (value) {
        const data = { id: this.competitor.id, gold: 0, silver: value, bronze: 0 }
        this.$store.dispatch('Sport/Competitor/put', data)
      }
    },
    bronze: {
      get () { return this.competitor.bronze },
      set (value) {
        const data = { id: this.competitor.id, gold: 0, silver: 0, bronze: value }
        this.$store.dispatch('Sport/Competitor/put', data)
      }
    },

    persons () { return this.$store.getters['Sport/CompetitorPerson/getCompetitor'](this.competitor.id) },
    scores () { return this.$store.getters['Sport/CompetitorScore/getCompetitor'](this.competitor.id) },
    searchedPerson () {
      return this.$store.getters['Main/Person/list']
    },
    searchLoading () { return this.searchState.length > 0 && this.$store.getters['Main/Person/loading'] },
    statuses () { return this.$store.getters['Sport/GameStatus/list'] },
    status () { return this.$store.getters['Sport/GameStatus/get'](0) },
    statusName () { return this.status.name },
    statusGame: {
      get () { return this.statusName },
      set (value) {
        this.statusOpen = false
        const data = {
          competitorId: this.competitor.id,
          order: 1,
          score: 0,
          statusId: this.statuses.find(item => item.name === value).id
        }
        this.$store.dispatch('Sport/CompetitorScore/post', data)
      }
    },

    scoreDiscipline () { return this.$store.getters['Sport/ScoreDiscipline/get'](this.disciplineId) }
  },
  methods: {
    countryUrl (countryId) { return 'https://media.api.idalgo.info/Country/svg/country_' + countryId + '.svg' },
    changeOrder (event) {
      this.$store.dispatch('Sport/Competitor/put', { id: this.competitor.id, order: event.target.value })
    },
    changeRanking (event) {
      this.$store.dispatch('Sport/Competitor/put', { id: this.competitor.id, ranking: event.target.value })
    },
    changeTeam (team) {
      this.$store.dispatch('Sport/Competitor/put', { id: this.competitor.id, teamId: team.id })
    },
    clearTeam () {
      this.$store.dispatch('Sport/Competitor/put', { id: this.competitor.id, teamId: null })
    },
    searchedTeam (value, callBack) {
      callBack(this.$store.getters['Sport/Team/search'](value, this.eventUnitId, this.sportId).map(item => {
        return { value: (item.order ? '#' + item.order + ' ' : '') + item.nameFr + ' [' + item.id + ']', id: item.id }
      }))
    },
    remove () {
      this.$store.dispatch('Sport/Competitor/delete', this.competitor.id)
    },
    searchPerson (query, callback) {
      const parameters = {}
      if (parseInt(query) && query.length === parseInt(query).toString().length) {
        parameters.id = query
      } else if (query.length > 4) {
        parameters.operator = 'OR'
        parameters.name = { column: 'nameFr', operator: 'like', insensitive: 1, value: '%' + query.trim() + '%' }
        parameters.firstname = { column: 'firstnameFr', operator: 'like', insensitive: 1, value: '%' + query.trim() + '%' }
        parameters.nickname = { column: 'nicknameFr', operator: 'like', insensitive: 1, value: '%' + query.trim() + '%' }
      }

      if (Object.keys(parameters).length > 0) {
        parameters.callback = callback
        parameters.include = [{ module: 'Countries' }]
        this.$store.dispatch('Main/Person/get', parameters)
      }
    },
    searchTitle (item) { return item.firstnameFr + ' ' + item.nameFr + ' #' + item.id + ' ' + date(item.dateBirth) },
    addPerson (value) {
      const data = {
        competitorId: this.competitor.id,
        personId: value.id,
        order: 1,
        callParameters: { include: [{ column: 'personId' }] }
      }
      this.$store.dispatch('Sport/CompetitorPerson/post', data)
    },
    state (status) { return status.live ? 1 : (status.stopped ? 2 : (status.ended ? 3 : 0)) } /* To delete */
  }
}
</script>

<style scoped>
  .competitor{
    flex:1 1 auto;
    display:flex;
    align-items:center;
    margin:1px
  }
  .competitor > .medals{
    display:block;
    flex:0 0 15px;
    width:15px;
    height:15px;
    border-radius:50%
  }
  .competitor > .medals.gold{
    background-color:gold
  }
  .competitor > .medals.silver{
    background-color:silver
  }
  .competitor > .medals.bronze{
    background-color:maroon
  }
  .competitor > .ranking,
  .competitor > .order{
    flex:0 0 25px;
    font-size:14px;
    text-align:right;
    width:20px;
    margin-left:5px
  }
  .competitor > .country{
    width:30px;
    display:flex;
    align-items:center;
    justify-content:center
  }
  .competitor > .country > img{
    width:20px;
    border-radius:2px;
    border:1px solid var(--color-disable-bg)
  }
  .competitor > .team{
    margin-left:5px;
    flex: 1 1 auto;
  }
  .competitor > button{
    margin-left:10px
  }
  .competitor > button > i{
    margin-right:10px;
    color:red
  }
  .competitor > .medal{
    margin-left:10px
  }
  .competitor > .persons{
    display:flex;
    flex:1 1 auto;
    flex-direction:row;
    background-color:var(--color-primary);
    padding:5px;
    margin-left:10px;
    border-radius:4px
  }
  .competitor > .persons > .list{
    display:flex;
    flex-direction:column;
    justify-content:center
  }
  .competitor > .scores{ /* To delete */
    display:flex;
    flex:1 1 auto;
    flex-direction:row;
    background-color:var(--color-primary);
    padding:5px;
    margin-left:10px;
    border-radius:4px;
    gap:5px
  }
  .competitor > .scores > button{ /* To delete */
    border-style:none;
    background-color:transparent;
    padding:0;
    margin-right:5px
  }
  .competitor > .scores > .list{ /* To delete */
    display:flex;
    flex-direction:column;
    justify-content:center
  }

</style>
<style>
  .search-person-popper li{
    display:flex;
    justify-content:flex-start;
    align-items:center;
    padding:5px
  }
  .search-person-popper .flag{
    width:20px;
    border-radius:2px;
    border:1px solid var(--color-disable-bg);
    margin-right:5px
  }
  .search-person-popper .name{
    display:flex;
    font-size:14px;
    flex-wrap:wrap;
    line-height:16px
  }
  .search-person-popper .name > strong{
    display:flex;
    flex-wrap:wrap;
    margin-right:5px
  }
  .search-person-popper .name > small{
    display:flex;
    flex-wrap:wrap
  }
  .el-autocomplete-suggestion.el-popper{
    width:initial !important;
  }
</style>
